module.exports = __webpack_public_path__ + "img/clear-responses-icon.6252b5ae.svg";